module.exports = __webpack_public_path__ + "img/Slide4.fd81a739.png";